export enum PREVIEW_AUDIO_END_PROMPT_SCOPE {
    post = 'post',
    chapter = 'chapter',
    section = 'section',
}

export default PREVIEW_AUDIO_END_PROMPT_SCOPE;
